module.exports = __webpack_public_path__ + "static/media/YF16_3.c38ed657.jpg";